import { render, staticRenderFns } from "./TUIOrderStateChip.vue?vue&type=template&id=26fc5460"
import script from "./TUIOrderStateChip.vue?vue&type=script&lang=js"
export * from "./TUIOrderStateChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports